import api from 'api';

export const loadApplications = api(
  'GET /api/hourly-tracker/filters/applications'
);
export const loadNetworks = api('GET /api/hourly-tracker/filters/networks');
export const loadPlatforms = api('GET /api/hourly-tracker/filters/platforms');
export const loadTrafficTypes = api(
  'GET /api/hourly-tracker/filters/traffic-types'
);
export const loadClusters = api('GET /api/hourly-tracker/filters/clusters');
export const loadTimeZones = api('GET /api/hourly-tracker/filters/timezones');
export const loadOwners = api('GET /api/hourly-tracker/filters/owners');
export const loadCountries = api('GET /api/hourly-tracker/filters/countries');
export const loadManagers = api('GET /api/hourly-tracker/filters/managers');

export const loadAffiliates = api('GET /api/hourly-tracker/filters/affiliates');

export const loadFilterDetails = api(
  'POST /api/hourly-tracker/filters-details'
);
